import React from 'react';

import { Link } from 'react-router-dom';  
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

const Footer = () => {
    return (
        <div className="container">
            <footer className="footer">
                <div className="footer-links">
                    <Link to="/">Home</Link>
                    <Link to="/contact">Contact</Link>
                    <Link to="/Login">Log in</Link>
                    <div className='Mui'>
                    <a href="https://www.instagram.com/aadvandam7?igsh=MXhkZ3UxYW1naTBiMQ==" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
                    <a href="https://www.facebook.com/people/Beeldhouwer-Aad-van-Dam/100083266574756/" target="_blank" rel="noopener noreferrer"><FacebookIcon /></a>
                    </div>
                </div>
                <p>© 2025 Aad van Dam | Alle rechten voorbehouden.</p>
            </footer>
        </div>
    );
};

export default Footer;
